<script setup lang="ts">
import { onMounted } from 'vue';
import { useUserStore } from '@/stores/user';
import MxLayout from '@/components/MxLayout.vue';
import type { ClientErrorIn } from '@/api/types';

const userStore = useUserStore();
const APP_VERSION = '0.3.0';

function reportError(message: string, stack?: string) {
  const body: ClientErrorIn = {
    message,
    stack: stack ?? null,
    url: window.location.pathname,
    app_version: APP_VERSION,
  };
  // Best-effort fire-and-forget; don't await.
  void fetch('/api/v1/_client_error', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

onMounted(() => {
  const tg = (window as any).Telegram?.WebApp;
  tg?.ready();
  tg?.expand();
  void userStore.load();

  window.addEventListener('error', (e) => {
    reportError(e.message ?? 'window.onerror', e.error?.stack);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const reason = (e as any).reason;
    reportError(
      typeof reason === 'string' ? reason : (reason?.message ?? 'unhandledrejection'),
      reason?.stack,
    );
  });
});
</script>

<template>
  <MxLayout />
</template>
